import clsx from "clsx";
import PropTypes from "prop-types";

import { useUpdateLinkTracking } from "@hooks/use-update-link-tracking";

import { ExternalLink } from "@features/ui/external-link";

import "./copyright-footer.scss";

const FIRST_YEAR = 2024;

export const CopyrightFooter = ({ className }) => {
  const currentYear = new Date().getFullYear();

  useUpdateLinkTracking();

  return (
    <div className={clsx("copyright-footer", className)}>
      <div>
        Copyright &copy; {FIRST_YEAR}
        {currentYear > FIRST_YEAR ? ` - ${currentYear}` : ""} Transfr Inc. All
        Rights Reserved.
      </div>
      <div>
        <ExternalLink href="https://transfrinc.com/privacy-policy/">
          Privacy Policy
        </ExternalLink>{" "}
        &bull;
        <ExternalLink href="https://transfrinc.com/terms/">
          Terms of Use
        </ExternalLink>
      </div>
    </div>
  );
};

CopyrightFooter.propTypes = {
  className: PropTypes.string,
};
